export default "__VITE_ASSET__620eebb6__"